import { connect } from 'react-redux'
import { useIntl } from 'react-intl'
import { LuxTextInput, LuxSelect, LuxMultiSelect, Color } from '@lux/wardrobe-lib'
import { FormBase, ProjectTitleForm } from '@models/new-activity-form'
import { FILTERS_REDUCER_NAMESPACE } from '@/app/redux/reducers/filters'
import './ProjectTitle.scss'

const ProjectTitle = (props: FormBase<ProjectTitleForm>) => {
    const componentClass = 'smart-new-activity-main-info-project-title'
    const { form, onSetForm, departmentList, recipientList } = props
    const intl = useIntl()

    return (
        <div className={componentClass}>
            <div className={`${componentClass}__title-input`}>
                <LuxTextInput
                    value={form.title.value}
                    onChangeCallback={(value) =>
                        onSetForm({ ...form, title: { ...form.title, value } })
                    }
                    mandatory={form.title.mandatory}
                    disabled={form.title.disabled}
                    label={intl.formatMessage({
                        id: 'modals.new.activity.section.main.info.project.title',
                        defaultMessage: 'Project title',
                    })}
                    placeholder={intl.formatMessage({
                        id: 'modals.new.activity.section.main.info.project.title.placeholder',
                        defaultMessage: 'Type here',
                    })}
                    style={{ backgroundColor: Color.WHITE }}
                />
            </div>
            {props.children}
            {!props.children && (
                <div className={`${componentClass}__select-department`}>
                    <LuxSelect
                        value={form.department.value}
                        onChangeCallback={(value) =>
                            onSetForm({ ...form, department: { ...form.department, value } })
                        }
                        mandatory={form.type.value !== 'photographic'}
                        clearable={form.type.value === 'photographic'}
                        disabled={form.department.disabled}
                        label={intl.formatMessage({
                            id: 'modals.new.activity.section.main.info.select.department',
                            defaultMessage: 'Select department',
                        })}
                        options={departmentList.map((department) => ({
                            ...department,
                            label: intl.formatMessage({
                                id: department.label,
                                defaultMessage: department.label.split('.').pop(),
                            }),
                        }))}
                        placeholder={intl.formatMessage({
                            id: 'modals.new.activity.section.main.info.select.department',
                            defaultMessage: 'Select department',
                        })}
                        additionalProps={{
                            appendTo: 'self',
                        }}
                    />
                    <LuxMultiSelect
                        value={form.recipient.value}
                        onChangeCallback={(value) =>
                            onSetForm({ ...form, recipient: { ...form.recipient, value } })
                        }
                        mandatory={true}
                        disabled={form.recipient.disabled}
                        label={intl.formatMessage({
                            id: 'modals.new.activity.section.main.info.select.recipient',
                            defaultMessage: 'Select recipiet',
                        })}
                        options={recipientList.map((recipient) => ({
                            ...recipient,
                            label: intl.formatMessage({
                                id: recipient.label,
                                defaultMessage: recipient.label.split('.').pop(),
                            }),
                        }))}
                        placeholder={intl.formatMessage({
                            id: 'modals.new.activity.section.main.info.select.recipient',
                            defaultMessage: 'Select recipient',
                        })}
                        additionalProps={{
                            appendTo: 'self',
                        }}
                    />
                </div>
            )}
        </div>
    )
}

const mapStateToProps = (state: any) => ({
    departmentList: state[FILTERS_REDUCER_NAMESPACE].departmentList,
    recipientList: state[FILTERS_REDUCER_NAMESPACE].recipientList,
})

const mapDispatchToProps = (dispatch: any) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(ProjectTitle)
